import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { Check, AlertCircle } from "lucide-react";
import api from "../lib/api";

export default function Unsubscribe() {
  const [params] = useSearchParams();
  const [status, setStatus] = useState("loading"); // loading | done | error
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    const token = params.get("token");
    if (!token) { setStatus("error"); setErrorMsg("Missing or invalid link."); return; }
    (async () => {
      try {
        await api.get(`/unsubscribe?token=${encodeURIComponent(token)}`);
        setStatus("done");
      } catch (e) {
        setStatus("error");
        setErrorMsg(e.response?.data?.detail || "We couldn't process this unsubscribe link.");
      }
    })();
  }, [params]);

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-4" data-testid="unsubscribe-page">
      <div className="max-w-md w-full text-center">
        {status === "loading" && (
          <p className="text-[#888] text-sm tracking-wide">Processing your request…</p>
        )}
        {status === "done" && (
          <>
            <Check size={32} className="text-[#D4AF37] mx-auto mb-4" />
            <h1 className="text-2xl sm:text-3xl font-black tracking-tighter uppercase text-[#F5F5F5] mb-3">You're unsubscribed.</h1>
            <p className="text-sm text-[#A3A3A3] leading-relaxed mb-6">
              We won't send you any more reminder emails. Your account and your profile stay exactly as they are — you can come back any time.
            </p>
            <Link to="/" className="inline-flex items-center justify-center gap-2 bg-transparent border border-[#262626] text-[#E5E5E5] uppercase tracking-wider text-xs px-5 py-2.5 rounded-full hover:border-[#D4AF37]/40 transition-colors">
              Back to homepage
            </Link>
          </>
        )}
        {status === "error" && (
          <>
            <AlertCircle size={32} className="text-[#D4AF37] mx-auto mb-4" />
            <h1 className="text-xl font-black tracking-tighter uppercase text-[#F5F5F5] mb-3">Couldn't unsubscribe</h1>
            <p className="text-sm text-[#A3A3A3] leading-relaxed">{errorMsg}</p>
          </>
        )}
      </div>
    </div>
  );
}
